import { NbJSThemeOptions, DEFAULT_THEME as baseTheme } from '@nebular/theme';

export const MODERN_THEME = {
  name: 'modern',
  base: 'default',
  variables: {
    // Solo cambiar los colores principales
    primary: '#3498db',
    success: '#2ecc71',
    warning: '#f39c12',
    danger: '#e74c3c',
    info: '#3498db',
  },
}; 